/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {SpatialUtilService} from './spatial-util.service';
import {AlertModalService} from '../../common/component/modal';
import {NgEventBus} from 'ng-event-bus';
import {catchError, map, of, tap, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeatureApplyDeleteService {
    title = 'FeaturesApplyDeleteService';

    constructor(
        private spatialUtilService: SpatialUtilService,
        private alertModalService: AlertModalService,
        private eventBus: NgEventBus
    ) {}

    findAnglesInOverlappingEnlargements(parentid: any, features: any, array: any) {
        features.forEach(angle => {
            if (angle.attributes.parentid) {
                if (angle.attributes.parentid === parentid) {
                    array.push(angle);
                }
            }
        });
    }

    commitFeaturesDeletion(featureLayer: any, features: any, anglesDeleteFlag: any) {
        const featureLayerType = this.spatialUtilService.getFeatureLayerName(featureLayer);
        console.debug(this.title + ' : commitFeaturesDeletion - TYPE: ' + featureLayerType);

        if (features.length === 0) {
            return of([]);
        }

        const featuresToBeDeleted = features.slice();
        const deleteRelatedFeatures = [];

        if (featureLayerType === 'angle') {
            const response = this.spatialUtilService.getAngles().filter(f => f.attributes.enlargementid || f.attributes.enlargementids);

            if (response.length > 0) {
                features.forEach(featureToBeDeleted => {
                    //TODO [PAU-462]: Integrate enlargementUtilService.getEnlargementIds when enlargementUtilService is ready
                    //const idsOfSource = enlargementUtilService.getEnlargementIds(featureToBeDeleted);
                    const idsOfSource = ['mockId1', 'mockId2', 'mockId3'];
                    response.forEach(angle => {
                        if (featureToBeDeleted.attributes.parentid && anglesDeleteFlag) {
                            if (angle.attributes.id === featureToBeDeleted.attributes.parentid) {
                                deleteRelatedFeatures.push(angle);
                                this.findAnglesInOverlappingEnlargements(featureToBeDeleted.attributes.parentid, response, deleteRelatedFeatures);
                            }
                        }
                        if (idsOfSource.length && anglesDeleteFlag) {
                            idsOfSource.forEach(enlargementId => {
                                if (angle.attributes.enlargementid === enlargementId) {
                                    deleteRelatedFeatures.push(angle);
                                }
                            });
                        }
                    });
                });
            }

            const deleteHiddenFeatures = [];

            deleteRelatedFeatures.forEach(item => {
                let isExisting = false;
                features.forEach(existingItem => {
                    if (existingItem.attributes.id === item.attributes.id) {
                        isExisting = true;
                    }
                    console.log(isExisting);
                });
                if (!isExisting) {
                    let addItem = false;
                    features.forEach(existingItem => {
                        if (existingItem.attributes.legacylocalangleno) {
                            if (existingItem.attributes.legacylocalangleno === item.attributes.legacylocalangleno) {
                                addItem = true;
                                item.attributes.internalangle = existingItem.attributes.internalangle;
                            }
                        } else {
                            if (
                                existingItem.attributes.anglefromlineid === item.attributes.anglefromlineid &&
                                existingItem.attributes.angletolineid === item.attributes.angletolineid
                            ) {
                                item.attributes.internalangle = existingItem.attributes.internalangle;
                                addItem = true;
                            }
                        }
                    });

                    if (addItem) {
                        deleteHiddenFeatures.push(item);
                    }
                }
            });

            if (deleteHiddenFeatures && deleteHiddenFeatures.length > 0) {
                console.log(deleteHiddenFeatures);
                this.spatialUtilService.applyEdits('angle', null, null, deleteHiddenFeatures).pipe(
                    tap(res => {
                        console.debug(`${this.title} : angles deleted:`, res.deletes);
                    })
                );
            }
        }

        return this.spatialUtilService.applyEdits(featureLayer, null, null, features).pipe(
            map(res => {
                console.debug(this.title + ' : commitFeaturesDeletion - TYPE: ' + featureLayer.id + ' deletes: ', res.deletes);
                const unsuccessfulFeatures = res.deletes.filter(v => v.error);

                if (unsuccessfulFeatures.length === 0) {
                    this.spatialUtilService.unhighlightFeatures(featureLayer, featuresToBeDeleted);
                    this.eventBus.cast('remove' + featureLayerType + 'Features', featuresToBeDeleted);

                    if (featureLayerType === 'point') {
                        this.eventBus.cast('removecontrolPointFeatures', featuresToBeDeleted);
                    }
                    return features;
                } else {
                    return throwError(() => {
                        new Error();
                    });
                }
            }),
            catchError(() => {
                console.error('Error deleting features');
                return throwError(() => {
                    new Error();
                });
            })
        );
    }
}
